<script setup>
// Presentazionale: nessuna dipendenza dal SW. App.vue passa lo stato e
// gestisce gli eventi. Montato solo fuori da /admin.
import { ref, computed, watch } from 'vue'
import { Download } from 'lucide-vue-next'
import CountdownButton from '../ui/CountdownButton.vue'
const props = defineProps({
  needRefresh: { type: Boolean, default: false },
  canInstall: { type: Boolean, default: false },
  // Durante l'intro d'ingresso della Home l'overlay resta nascosto (opacità 0 +
  // non cliccabile) e compare in dissolvenza insieme al resto della UI.
  introHidden: { type: Boolean, default: false }
})
defineEmits(['install', 'update'])

// Il pulsante "Installa app" resta per 20s poi sparisce (fine countdown).
// Ricompare al prossimo mount (app riaperta o pagina ricaricata) → stato locale.
const installTimedOut = ref(false)
const showInstall = computed(() => props.canInstall && !installTimedOut.value)

// Reset del countdown quando l'install torna disponibile.
watch(() => props.canInstall, (v) => {
  if (v) installTimedOut.value = false
})
</script>

<template>
  <!-- bottom offset: sopra la bottom-nav fixed della Home (~3.5rem + safe-area) -->
  <div
    class="pointer-events-none fixed inset-x-0 bottom-[calc(env(safe-area-inset-bottom,0px)+4.25rem)] z-50 flex flex-col items-center gap-2 px-4 transition-opacity duration-500"
    :class="introHidden ? 'opacity-0' : 'opacity-100'"
  >
    <CountdownButton
      v-if="showInstall"
      :seconds="20"
      button-class="btn-primary"
      bar-class="bg-white"
      rounded-class="rounded-xl"
      :wrapper-class="`${introHidden ? 'pointer-events-none' : 'pointer-events-auto'} shadow-lg shadow-mojito-900/25 transition-transform active:scale-95`"
      data-test="install"
      aria-label="Installa app"
      @click="$emit('install')"
      @timeout="installTimedOut = true"
    >
      <Download class="size-4" aria-hidden="true" />
      Installa app
    </CountdownButton>

    <div
      v-if="needRefresh"
      role="alert"
      class="alert alert-info max-w-sm rounded-xl shadow-lg"
      :class="introHidden ? 'pointer-events-none' : 'pointer-events-auto'"
    >
      <span>Nuova versione disponibile.</span>
      <button
        type="button"
        data-test="update"
        class="btn btn-sm rounded-xl"
        @click="$emit('update')"
      >
        Aggiorna
      </button>
    </div>
  </div>
</template>
